export default "__VITE_ASSET__262fcc05__"